import { useEffect } from "react";
import {
  ContainerV2,
  H1,
  P,
  InputDateRHFV2,
  SelectRHFV2,
  MyModal,
  ButtonV2,
} from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { reverseToBrDate, formatDateToISO } from "../../../utils/dateTransform";
import { useScheduleConfirmationV2 } from "./useScheduleConfirmationV2";

export const ScheduleConfirmationV2 = () => {
  const {
    stepIndicator,
    diasIndisponiveis,
    date,
    handleDateChange,
    horarios,
    horaAgendada,
    setHoraAgendada,
    handleSubmit,
    podeSubmeter,
    isSubmitting,
    isDateLocked,
    isReagendamentoModalOpen,
    setIsReagendamentoModalOpen,
    handleConfirmarReagendamento,
  } = useScheduleConfirmationV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/confirmar-horario:pageview");
  }, []);

  return (
    <ContainerV2
      backButton={{ className: "h-[38px]" }}
      nextButton={{
        title: "Finalizar agendamento",
        disabled: !podeSubmeter || isSubmitting,
        type: "submit",
        form: "schedule-confirmation-form",
        className: "h-[38px]",
      }}
    >
      {stepIndicator}
      <H1 className="mb-4 mt-8">Quando você prefere?</H1>
      <P className="mb-8 text-[#666666]">Escolha o dia e horário disponiveis.</P>

      <form
        id="schedule-confirmation-form"
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 rounded-[10px] border border-solid border-[#adb7b5] bg-white p-8 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)] sm:flex-row sm:items-start"
      >
        <InputDateRHFV2
          id="data"
          label="Data*"
          minDate={new Date()}
          disabled={isDateLocked}
          selected={date}
          excludeDates={diasIndisponiveis}
          onChange={handleDateChange}
        />

        <SelectRHFV2
          id="horario"
          label="Horário*"
          placeholder="Selecione"
          disabled={!date}
          options={horarios}
          value={horaAgendada ?? ""}
          onChange={(e) => setHoraAgendada(e.target.value)}
        />
      </form>

      <MyModal
        isOpen={isReagendamentoModalOpen}
        onRequestClose={() => setIsReagendamentoModalOpen(false)}
      >
        <div className="flex w-[400px] flex-col gap-6 p-8">
          <p className="font-['Mulish'] text-base text-[#20332f]">
            <strong>Confirma</strong> sua vistoria para o dia{" "}
            <strong>
              {date ? reverseToBrDate(formatDateToISO(date)) : ""} às{" "}
              {horaAgendada}
            </strong>
            ?
          </p>

          <div className="flex justify-end gap-4">
            <ButtonV2
              variant="text"
              type="button"
              onClick={() => setIsReagendamentoModalOpen(false)}
            >
              Cancelar
            </ButtonV2>
            <ButtonV2
              type="button"
              disabled={isSubmitting}
              onClick={handleConfirmarReagendamento}
            >
              Confirmar
            </ButtonV2>
          </div>
        </div>
      </MyModal>
    </ContainerV2>
  );
};
